import React from 'react'
import '../Css/detailcard.css'
import { Link } from 'react-router-dom';

const DetailCard = ({lists}) => {
  console.log(lists)
  return (
    <>
      <div className="main-container">
        <div className="img-info-container" id={lists}>
          <img
            className="card-img"
            src={lists.imageUrl}
            // width={500}
            alt=""
          />
          <div className='info-card'>
            <h1 className="card-heading">{lists.heading}</h1>
            <div>
            {
              lists.intro.map((para)=>{
                return(
                <p style={{marginTop: "1rem"}}>{para}</p>
                )
              })
            }
            </div>
            <p>
              <br />
              <span style={{ fontWeight: "600", fontSize: "x-large" }}>
                Features:
              </span>
              <br />
              <ul>
                {
                  lists.features.map((lis)=>{
                    return(
                      <li>
                        {lis}
                      </li>
                    )
                  })
                }
              </ul>
            </p>
            {
            lists.structure? 
            <p style={{marginTop: "1rem"}}>
              <span style={{ fontWeight: "600", fontSize: "x-large" }}>
                Structure:
              </span>
              <ul>
              {
                  lists.structure.map((lis)=>{
                    return(
                      <li>
                        {lis}
                      </li>
                    )
                  })
              }
              </ul>
            </p>
            :<></>}
            <div className="butt">
              <div className="doc-req">Document Request</div>
              <Link className='enq' to={"/contact"}>Enquire Now</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailCard